<template>
  <div>
    <Navbar :logo="logo_src" :alt="app_name"></Navbar>
    <Transition>
      <div id="load" class="d-none position-fixed top-0 z-3 w-100 h-100" style="z-index: 9999;">
        <div class="spinner-grow position-fixed start-50 top-50 z-3" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </Transition>
    <Transition>
      <router-view style="min-height: 70vh;" />
    </Transition>
    <Modal tamanho_modal="modal-xl" textoBtnChamada="" id_modal="modal_livro" :exibe_botao="false" titulo-modal=""
      @click_bt_modal="click_bt_modal()" @hidden="hidden">
      <template #default>
        <div class="row h-100">
          <div class="col-12">
            <youtube :link="link_video" />
          </div>
          <div class="col-12 text-center d-grid gap-2">
            <a href="https://mercadolivre.com/sec/1H5V8fK" target="_blank" class="btn btn-success btn-lg">Comprar o
              livro</a>
          </div>
        </div>
      </template>
    </modal>
    <Whatsapp txt="Entro em contato pelo site saiadosofabr.com.br e gostaria de saber mais." telefone="5524998781800" />
    <Footer :logo="logo_src_rodape" :alt="app_name"></Footer>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";
import Whatsapp from "./components/Whatsapp.vue";
import Modal from "./components/Modal.vue";
import Youtube from './components/Youtube.vue';

export default {
  components: {
    Navbar,
    Footer,
    Whatsapp,
    Modal,
    Youtube,
  },
  data() {
    return {
      logo_src: "/img/logo.png",
      logo_src_rodape: "/img/logo.light.png",
      app_name: "Saia do sofá",
      link_video: null
    };
  },
  methods: {
    click_bt_modal() {
      this.link_video = 'https://www.youtube.com/watch?v=pWjmpSD-ph0';
    },
    hidden() {
      this.link_video = null;
    },
  },
};
</script>

<style>
p::first-letter {
  margin-left: 12px !important;
}
.v-enter-active,
.v-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

#load {
  color: var(--cor-base-texto);
}

#load::before {
  content: '';
  background-color: var(--cor-base-fundo);
  opacity: .5;
  position: fixed;
  top:0px;
  width: 100vw;
  height: 100vh;
}

.v-enter-from,
.v-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

* {
  font-family: 'montserrat';
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

/* div, h2 {
  border: 1px solid red;
} */

.main-container {
  margin-top: 10px;
  min-height: 60vh;
}

.paragrafo::first-letter {
  color: var(--cor-base-texto) !important;
  font-size: 22px !important;
  font-weight: bold !important;
  margin-left: 12px !important;
}

.paragrafo p::first-letter {
  margin-left: 12px;
}

.paragrafo p {
  margin-top: -20px !important;
  font-weight: bold;
}

.bg-fixo::before {
  content: "";
  position: absolute;
  padding: 0px !important;
  margin-top: 0px;
  left: 0px;
  width: 100%;
  height: 60%;
  opacity: 1;
  z-index: -999;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed, scroll !important;
}
</style>
